/**
 * A country code for display, always upper case.
 *
 * iso2 is stored inconsistently - the same User List shows "sg" on one row and
 * "SG" on the next, because different sign-up paths wrote it differently. Every
 * Country column renders the stored value directly, so the inconsistency is
 * visible throughout the admin portal. Upper case is the ISO 3166-1 alpha-2
 * form and the one the rest of the portal uses.
 *
 * Display only: it does not change what is stored, and filters and sorting are
 * unaffected.
 */
export function formatCountryCode(value: unknown): string {
  const code = String(value ?? "").trim();
  return code ? code.toUpperCase() : "—";
}
